import { Button, Card, Table, Tag, Input, Select, Space } from "antd";
import { PlusOutlined, EyeOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";
import { loadAllWorkers } from "../../redux/actions/hr/workerActions";

const WorkerList = () => {
  const dispatch = useDispatch();
  const { list, total, loading } = useSelector((s) => s.workers);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("true");

  useEffect(() => {
    dispatch(loadAllWorkers({ page, count: 20, status: statusFilter, search: search || undefined }));
  }, [dispatch, page, statusFilter]);

  const handleSearch = () => {
    setPage(1);
    dispatch(loadAllWorkers({ page: 1, count: 20, status: statusFilter, search: search || undefined }));
  };

  const columns = [
    { title: "Name", dataIndex: "name", key: "name", render: (t, r) => <Link to={`/hr/workers/${r.id}`}>{t}</Link> },
    { title: "Phone", dataIndex: "phone", key: "phone" },
    { title: "Type", dataIndex: "worker_type", key: "worker_type", render: (v) => v ? <Tag>{v}</Tag> : "-" },
    { title: "Designation", dataIndex: "designation", key: "designation" },
    {
      title: "Salary Type", dataIndex: "salary_type", key: "salary_type",
      render: (v) => <Tag color={v === "monthly" ? "blue" : "green"}>{v}</Tag>,
    },
    {
      title: "Rate", key: "rate",
      render: (_, r) => r.salary_type === "monthly" ? `₹${r.monthly_salary?.toLocaleString()}/mo` : `₹${r.hourly_rate}/hr`,
    },
    { title: "Shift Hrs", dataIndex: "shift_hours", key: "shift_hours", width: 80 },
    {
      title: "Status", dataIndex: "status", key: "status", width: 80,
      render: (v) => v ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>,
    },
    {
      title: "", key: "actions", width: 50,
      render: (_, r) => <Link to={`/hr/workers/${r.id}`}><Button type="link" icon={<EyeOutlined />} size="small" /></Link>,
    },
  ];

  return (
    <>
      <PageTitle title="Back" />
      <Card
        title="Workers"
        extra={<Link to="/hr/workers/add"><Button type="primary" icon={<PlusOutlined />}>Add Worker</Button></Link>}
      >
        <Space style={{ marginBottom: 16 }} wrap>
          <Input.Search
            placeholder="Search name / phone"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onSearch={handleSearch}
            style={{ width: 250 }}
            allowClear
          />
          <Select value={statusFilter} onChange={(v) => { setStatusFilter(v); setPage(1); }} style={{ width: 120 }}>
            <Select.Option value="true">Active</Select.Option>
            <Select.Option value="false">Inactive</Select.Option>
          </Select>
        </Space>
        <Table
          dataSource={list}
          columns={columns}
          rowKey="id"
          loading={loading}
          size="small"
          pagination={{ current: page, total, pageSize: 20, onChange: setPage }}
        />
      </Card>
    </>
  );
};

export default WorkerList;
